import { createQueryKeys } from '@lukemorales/query-key-factory';
import { EQueryKeys } from 'common/enums/query-kyes.enum';
import {
  getCounterpartyAccountDetailsService,
  getCounterpartyAccountsService,
  getCounterpartyBranchAccountsService,
  getCustomerAccountsDetailsService,
} from '../services/accounts.service';
import {
  TAccountCustomersResData,
  TAccountsListReqParams,
  TAccountsListResData,
  TAccountDetailRes,
} from '../types/accounts.types';

export const accountsQueryKeys = createQueryKeys(EQueryKeys.AccountQueryKeys, {
  getAccountsList: (counterpartyGUID: string, customerGUID: string, params: TAccountsListReqParams = {}) => ({
    queryKey: ['customer-accounts-details', params, customerGUID],
    queryFn: (): Promise<TAccountCustomersResData> =>
      getCustomerAccountsDetailsService(counterpartyGUID, customerGUID, params),
  }),
  getCounterpartyAccounts: (counterpartyGUID: string, params: TAccountsListReqParams = {}) => ({
    queryKey: ['counterparties-accounts-list-all', params, counterpartyGUID],
    queryFn: (): Promise<TAccountsListResData> => getCounterpartyAccountsService(counterpartyGUID, params),
  }),
  getCounterpartyBranchAccounts:
    (counterpartyGUID: string, branchGUID: string,params: TAccountsListReqParams = {}) => ({
      queryKey: ['counterparties-branch-accounts-list-all', params, counterpartyGUID, branchGUID],
      queryFn: (): Promise<TAccountsListResData> =>
        getCounterpartyBranchAccountsService(counterpartyGUID, branchGUID, params),
  }),
  getCounterpartyAccountDetails: (
    counterpartyGUID: string,
    accountGUID: string,
    params: TAccountsListReqParams = {},
  ) => ({
    queryKey: ['counterparties-accounts-details-list-all', params, accountGUID, counterpartyGUID],
    queryFn: (): Promise<TAccountDetailRes> =>
      getCounterpartyAccountDetailsService(counterpartyGUID, accountGUID, params),
  }),
});
